// extracted by mini-css-extract-plugin
module.exports = {"badge":"GamePanel_badge__aFrw1","paper":"GamePanel_paper__p0pVs","itemIcon":"GamePanel_itemIcon__SpBjY","item":"GamePanel_item__gGe_d"};